function restoreValue(fallback: unknown, saved: unknown): unknown {
    if (saved == null)
        return fallback;
    if (!fallback || typeof fallback !== 'object' || Array.isArray(fallback)
        || typeof saved !== 'object' || Array.isArray(saved))
        return saved;
    const restored = { ...saved } as Record<string, unknown>;
    for (const key of Object.keys(fallback))
        restored[key] = restoreValue((fallback as Record<string, unknown>)[key], restored[key]);
    return restored;
}

export function restoreServiceRequestDraft<T extends { targetDeliveryDate: string }>(defaults: T, saved: Partial<Record<keyof T, unknown>>): T {
    const restored = { ...defaults };
    for (const key of Object.keys(defaults) as Array<keyof T>)
        restored[key] = restoreValue(defaults[key], saved[key]) as T[keyof T];
    restored.targetDeliveryDate = restored.targetDeliveryDate.slice(0, 10);
    return restored;
}
